import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SectionHeader from "./SectionHeader";
import SignedImage from "./SignedImage";
import { COLORS } from "../../theme/tokens";

function NumberedCard({ block }) {
  const c = block.content || {};
  return (
    <Stack
      spacing={2}
      sx={{
        height: "100%",
        backgroundColor: "#fff",
        borderRadius: 1,
        p: 2.75,
        border: "1px solid rgba(32, 48, 51, 0.14)",
        boxShadow: "0 16px 36px rgba(32, 48, 51, 0.08)",
        overflow: "hidden",
      }}
    >
      {c.s3Key && (
        <Box
          sx={{
            aspectRatio: "4 / 3",
            borderRadius: 1,
            overflow: "hidden",
            mx: -2.75,
            mt: -2.75,
          }}
        >
          <SignedImage s3Key={c.s3Key} alt={c.imageAlt || c.heading} />
        </Box>
      )}
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        {c.number && (
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              backgroundColor: "#EF7D00",
              color: "#203033",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "windroos, sans-serif",
              fontWeight: 900,
              fontSize: "1rem",
              flexShrink: 0,
            }}
          >
            {c.number}
          </Box>
        )}
        <Typography
          variant="h5"
          component="h3"
          sx={{ fontFamily: "windroos, sans-serif", color: COLORS.blue }}
        >
          {c.heading}
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ color: COLORS.muted }}>
        {c.body}
      </Typography>
    </Stack>
  );
}

export default function TextCardsSection({ section }) {
  const { content, blocks = [] } = section;
  const cards = blocks
    .filter((b) => b.blockType === "text-card")
    .sort((a, b) => a.order - b.order);

  return (
    <Box
      id="freinet"
      component="section"
      sx={{
        py: "clamp(48px, 7vw, 92px)",
        px: "clamp(20px, 5vw, 72px)",
        backgroundColor: "#fff",
        scrollMarginTop: { xs: 64, md: 80 },
      }}
    >
      <Container disableGutters sx={{ maxWidth: { md: 1160 } }} maxWidth={false}>
        <SectionHeader
          eyebrow={content.eyebrow}
          heading={content.heading}
          subheading={content.subheading}
          lead={content.lead}
          align="center"
          reviewStatus="aangepast"
        />
        <Grid container spacing="22px">
          {cards.map((block) => (
            <Grid key={block.id} size={{ xs: 12, md: 4 }}>
              <NumberedCard block={block} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
